import type { DirectiveBinding, ObjectDirective } from 'vue';

import { isRadarFileUrl, resolveAuthorizedFileUrl } from '@/core/authorizedFile';

type MediaElement = HTMLImageElement | HTMLVideoElement;

const applyAuthorizedSrc = async (
	element: MediaElement,
	binding: DirectiveBinding<string>,
) => {
	const url = binding.value ?? '';
	element.dataset.authSrc = url;

	if (!url.trim()) {
		element.removeAttribute('src');
		return;
	}

	try {
		const resolved = isRadarFileUrl(url) ? await resolveAuthorizedFileUrl(url) : url;
		if (element.dataset.authSrc !== url) return;
		element.src = resolved;
	} catch {
		if (element.dataset.authSrc !== url) return;
		element.dispatchEvent(new Event('error'));
	}
};

export const authSrc: ObjectDirective<MediaElement, string> = {
	mounted(element, binding) {
		void applyAuthorizedSrc(element, binding);
	},
	updated(element, binding) {
		if (binding.value !== binding.oldValue) {
			void applyAuthorizedSrc(element, binding);
		}
	},
};
